<template>
  <section
    class="shadow-md bg-white rounded-lg grid gap-4 grid-cols-2 overflow-hidden"
    :class="{ 'lg:hidden': design !== 'aside' }"
  >
    <div class="pl-6 py-6">
      <h2 class="text-lg md:text-2xl leading-none font-semibold">
        Ha’ Biltorvet <br />
        lige ved hånden
      </h2>
      <p class="pt-4 text-xs">
        Med Biltorvets nye app kan du søge efter biler nemt og bekvemt direkte
        fra din smartphone.
      </p>
      <div class="mt-4">
        <img
          class="hidden md:block w-24 h-auto"
          src="/static/img/raster/app/qr-download-transparent.png"
          alt="QR kode"
        />
        <div class="flex flex-col md:hidden gap-2">
          <a
            v-if="urlGooglePlay"
            :href="urlGooglePlay"
            :class="{ 'hidden md:block': userOS === 'iOS' }"
          >
            <img
              class="h-10"
              src="/static/img/raster/app/google-play-badge.svg"
              alt="Hent i Google Play"
            />
          </a>
          <a
            v-if="urlAppStore"
            :href="urlAppStore"
            :class="{ 'hidden md:block': userOS === 'Android' }"
          >
            <img
              class="h-10"
              src="/static/img/raster/app/app-store-badge.svg"
              alt="Hent i App Store"
            />
          </a>
        </div>
      </div>
    </div>
    <div class="-mb-2 w-full relative">
      <img
        class="absolute top-0 lg:top-6 -right-12 max-w-none"
        style="width: 130%; max-width: 380px"
        src="/static/img/raster/app/appIphone.png"
        alt="Hent i App Store"
      />
    </div>
  </section>
  <section
    v-if="design === 'full'"
    class="shadow-md bg-white rounded-lg hidden lg:grid gap-8 grid-cols-5 overflow-hidden"
  >
    <div class="pl-6 w-full relative">
      <img
        class="absolute top-6 max-w-none w-full"
        src="/static/img/raster/app/appIphone.png"
        alt="Hent i App Store"
      />
    </div>
    <div class="py-6 col-span-3 self-center">
      <div class="max-w-2xl">
        <h2 class="text-5xl leading-none font-semibold">
          Ha’ Biltorvet lige ved hånden
        </h2>
        <p class="pt-4 text-lg leading-relaxed">
          Med Biltorvets nye app kan du søge efter biler nemt og bekvemt direkte
          fra din smartphone. Uanset om du leder efter en brugt eller en spritny
          bil, giver appen dig adgang til et stort udvalg af køretøjer og
          mulighed for at kontakte sælgere direkte. Scan koden for at hente
          appen på din telefon.
        </p>
      </div>
    </div>
    <div class="pr-8 py-8 flex justify-end items-center">
      <img
        class="w-36 h-auto"
        src="/static/img/raster/app/qr-download-transparent.png"
        alt="QR kode"
      />
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      userOS: '',
    }
  },

  props: {
    design: { default: 'aside', type: String },
    urlAppStore: { default: '', type: String },
    urlGooglePlay: { default: '', type: String },
  },

  beforeMount() {
    this.userOS = this.detectUserOS()
  },

  methods: {
    detectUserOS() {
      const userAgent = navigator.userAgent

      if (/android/i.test(userAgent)) {
        return 'Android'
      } else if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'iOS'
      } else {
        return 'Other'
      }
    },
  },
}
</script>
